import React from 'react';
import {Typography,Link,Grid} from '@material-ui/core'
 function EirSelectedPlanDetails(props) { 
    return (             
          <div className='rounded-div'>
             <Grid container justify='center'>
                     <Typography className='selected-device'>{props.selectedText}</Typography>
                     <Typography className='selected-details'>{props.detailsText}</Typography>
                  <Grid xs={2} sm={2} >
                     <Link href={props.changeLink} >
                        <Typography className='selected-change'>change</Typography> 
                     </Link>
                  </Grid>
             </Grid>
         </div>         
        );  
      
  }
  export default EirSelectedPlanDetails;
  